import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Reveal } from "./Reveal";

export const TunnelBanner = () => {
  const { t } = useLang();
  const c = t.contact;
  return (
    <section data-testid="tunnel-banner" className="px-5 py-16 lg:px-8 lg:py-20">
      <Reveal className="relative isolate mx-auto flex min-h-[360px] max-w-7xl items-center overflow-hidden rounded-3xl border border-[#2F7BFF]/20 shadow-[0_30px_80px_-30px_rgba(47,123,255,.5)]">
        <img src="/img/tunnel.jpg" alt="" className="absolute inset-0 -z-10 h-full w-full object-cover" />
        <div className="absolute inset-0 -z-10 bg-gradient-to-l from-[#060A14] via-[#060A14]/70 to-transparent" />
        <div className="ml-auto max-w-lg p-8 sm:p-12">
          <h2 className="font-display text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-5xl">{c.closing}</h2>
          <p className="mt-4 text-base leading-relaxed text-slate-300">{c.p[2]}</p>
          <a href="/#contact" data-testid="tunnel-banner-cta" className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-[15px] font-bold text-[#0B1224] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#DCE8FF]">
            {t.nav.cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </Reveal>
    </section>
  );
};
